<template>
  <div>
    <Modal v-model="showModal" title="测试报告" width="1000">
      <Alert v-if="error" type="warning" show-icon>获取数据失败</Alert>
      <div v-else-if="readOnly">
        <Alert v-if="!content" show-icon>暂无</Alert>
        <div v-html="content" v-else></div>
      </div>
      <ReportEditor ref="ReportEditor" v-else :value="content" :cache="false"></ReportEditor>
      <div slot="footer">
        <Button type="primary" @click="submit" v-if="!readOnly" :loading="submitting">提交</Button>
        <Button @click="showModal = false">关闭</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import ReportEditor from '@/components/editor'
import { detailCodeReleaseFlow, submitCodeReleaseFlowTestReport } from '@/api/workflow/code_release_flow'

export default {
  name: 'test-report',
  components: {
    ReportEditor
  },
  data () {
    return {
      showModal: false,
      error: false,
      content: '',
      jobFlowId: null,
      jobFlow: {},
      readOnly: false,
      submitting: false
    }
  },
  methods: {
    // 打开对话框
    openModal (jobFlowId) {
      this.jobFlowId = jobFlowId
      this.getFlowData()
      this.showModal = true
    },
    // 获取工作流信息
    getFlowData () {
      detailCodeReleaseFlow(this.jobFlowId).then(res => {
        this.jobFlow = res.data
        this.content = res.data.test_report
        this.readOnly = !res.data.can_submit_test_report
        if (!this.readOnly) {
          this.$refs.ReportEditor.setHtml(this.content)
        }
        this.error = false
      }).catch(res => {
        console.log(res.response)
        this.error = true
      })
    },
    // 提交
    submit () {
      this.submitting = true
      submitCodeReleaseFlowTestReport(this.jobFlowId, this.$refs.ReportEditor.getHtml()).then(res => {
        this.$Notice.success({title: '提交成功！'})
        this.showModal = false
        this.submitting = false
        this.$emit('submitComplete')
      }).catch(res => {
        this.submitting = false
        console.log(res.response)
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！'
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
